// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3Dx1q","signatureButtonsRight":"ModalSign_signatureButtonsRight__-M_55"};